var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forbiden"},[_c('h2',[_vm._v("设备未注册")]),_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.goToCondig}},[_vm._v("前往设置")]),_c('van-button',{attrs:{"type":"primary"},on:{"click":_vm.play}},[_vm._v("播放测试")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }